import { PropsWithChildren, FunctionComponent } from 'react';
import RenderHealthProbe from 'src/components/RenderHealthProbe/RenderHealthProbe';
import AuthContextProvider from 'src/contexts/AuthContext';

/** INVARIANT: the probe must mount on the first commit, sibling of AuthContextProvider (which renders a Spinner instead of children). */
const BootHealthGate: FunctionComponent<PropsWithChildren> = ({ children }) => (
  <>
    <RenderHealthProbe />
    <AuthContextProvider>{children}</AuthContextProvider>
  </>
);

export default BootHealthGate;
